import React, { useContext, useEffect, useState } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";
import Pagination from "./Comman/Pagination";
import { useNavigate } from "react-router-dom";

export default function TransferEcosystem() {
  const {
    toastSuccess,
    toastError,
    formatDateTime,
    settings,
  } = useContext(OnmaxContext);

  const username = localStorage.getItem("username");

  /* ================= STATES ================= */
  const [amt, setAmt] = useState("");
  const [add, setAdd] = useState("");
  const [transferLoading, setTransferLoading] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const navigate = useNavigate();
  const [TransferStatus, setTransferStatus] = useState(false);
  const [TransferReason, setTransferReason] = useState('');

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [otp, setOtp] = useState("");

  const [udata, setUdata] = useState(null);

  // OTP
  const [showOtp, setShowOtp] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);

  //suggest name
  const [toUserName, setToUserName] = useState("");
  const [userCheckLoading, setUserCheckLoading] = useState(false);
  const [userCheckError, setUserCheckError] = useState("");

  const isRoundAmount = (value) => {
    const num = Number(value);
    return value !== "" && Number.isInteger(num) && num > 0;
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) {
      setAmt(value);
    }
  };


  const fetchToUser = async (username) => {
    if (!username) {
      setToUserName("");
      setUserCheckError("");
      return;
    }

    try {
      setUserCheckLoading(true);
      setUserCheckError("");

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "getname",
        key: process.env.REACT_APP_KEY,
        username: username,
      });

      if (res.data?.resCode === 200) {
        setToUserName(res.data.data.fromname);
      } else {
        setToUserName("");
        setUserCheckError("User not found");
      }
    } catch (err) {
      setToUserName("");
      setUserCheckError("Failed to verify user");
    } finally {
      setUserCheckLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchToUser(add);
    }, 600); // debounce

    return () => clearTimeout(timer);
  }, [add]);

  // Reset OTP status if amount or recipient changes to ensure "Every Transfer" is verified
  useEffect(() => {
    setOtpVerified(false);
    setShowOtp(false);
    setOtp("");
  }, [amt, add]);


  /* ================= USER DATA ================= */
  const getUserData = async () => {
    if (!username) return;
    setisLoading(true);
    const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
      method: "user",
      submethod: "profile",
      username,
      key: process.env.REACT_APP_KEY,
    });
    setisLoading(false);
    // console.log('ressssss',res.data.data);

    if (!res.data?.error) {
      setUdata(res.data.data);
    }
  };

  useEffect(() => {
    getUserData();
  }, [username]);


  /* ================= SEND OTP ================= */
  const sendOtp = async () => {
    // if (!udata?.contactno) {
    //   toastError("Verify Your Contact Number");
    //   navigate("/dashboard")
    //   return;
    // }
    if (!isRoundAmount(amt)) {
      toastError("Please enter a round figure amount (whole number only)");
      return;
    }

    if (udata?.ecosystem_balance < amt) {
      toastError("Insufficient balance for this transfer");
      return;
    }

    if (!udata?.email) {
      toastError("Verify Your Email");
      navigate("/verifyEmail")
      return;
    }

    try {
      setLoadingOtp(true);

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "send",
        key: process.env.REACT_APP_KEY,
        email: udata?.email,
        username,
        password: udata?.password,
      }
        // , {
        //   withCredentials: true
        // }
      );

      if (res.data?.resCode === 200) {
        toastSuccess("OTP sent to your email");
      }
      if (res.data?.resCode === 401) {
        toastError("Login Expired!");

        // Call logout immediately
        try {
          const logout = await axios.post(
            process.env.REACT_APP_BACKEND_LINK,
            {
              method: "user",
              submethod: "logoutu",
              username: username,
              key: process.env.REACT_APP_KEY,
            },
            { withCredentials: true }
          );
          console.log('res logout', logout);
          // Cookie.remove("token")
          localStorage.clear();
          // navigate("/");
          window.location.replace("/");
        } catch (error) {
          console.error("Logout failed:", error);
        }
      }

      if (res.data?.resCode === 400) {
        toastError(res.data.error);
        return;
      }
      setShowOtp(true);
    } catch {
      toastError("Failed to send OTP");
    } finally {
      setLoadingOtp(false);
    }
  };


  /* ================= VERIFY OTP ================= */
  const verifyOTP = async () => {
    if (otp.length !== 6) {
      toastError("Enter valid 6-digit OTP");
      return;
    }

    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "verifyemail",
        key: process.env.REACT_APP_KEY,
        email: udata.email,
        otp: otp,
      });
      if (res.data?.resCode === 200) {
        toastSuccess(res.data?.message || "OTP verified");

        setOtpVerified(true);
        setShowOtp(false);
        setOtp(""); // clear
      } else {
        toastError(res.data?.message || "Invalid OTP");
      }

    } catch {
      toastError("OTP verification failed");
    }
  };


  /* ================= TRANSFER ================= */
  const withdraw = async () => {
    if (!otp) {
      toastError("Verify OTP first");
      // navigate("/verifyEmail");
      return;
    }

    if (!isRoundAmount(amt)) {
      toastError("Please enter a round figure amount (whole number only)");
      return;
    }

    if (udata?.ecosystem_balance < amt) {
      toastError("Insufficient balance for this transfer");
      return;
    }

    setTransferLoading(true);

    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "transfer",
        submethod: "ecosystem",
        key: process.env.REACT_APP_KEY,
        // username: username,
        amount: amt,
        tusername: add,
        otp: otp,
      }, {
        withCredentials: true
      }
      );
      // console.log('res transfer', res);

      // if (res.data?.error) {
      //   toastError(res.data.error);
      //   return;
      // }

      // toastSuccess(res.data.msg || "Transfer successful");
      if (res.data?.resCode === 200) {
        toastSuccess(res.data.msg || "Transfer successful");
        setAmt("")
        setAdd("")
        setOtpVerified(false);
        setShowOtp(false);
        getUserData();
      }
      if (res.data?.resCode === 401) {
        toastError("Login Expired!");

        // Call logout immediately
        try {
          const logout = await axios.post(
            process.env.REACT_APP_BACKEND_LINK,
            {
              method: "user",
              submethod: "logoutu",
              username: username,
              key: process.env.REACT_APP_KEY,
            },
            { withCredentials: true }
          );
          // console.log('res logout', logout);
          // Cookie.remove("token")
          localStorage.clear();
          // navigate("/");
          window.location.replace("/");
        } catch (error) {
          console.error("Logout failed:", error);
        }
      }

      if (res.data?.resCode === 400) {
        toastError(res.data.error);
        return;
      }
      getTransferHistory();
    } catch (err) {
      toastError("Transfer failed. Please try again.");
    } finally {
      setTransferLoading(false);
    }
  };


  /* ================= HISTORY ================= */
  const getTransferHistory = async () => {
    const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
      method: "deposit",
      submethod: "getecosystembyid",
      username,
      page: currentPage,
      pageSize,
      key: process.env.REACT_APP_KEY,
    });
    // console.log('history', res.data.data, udata?.username);

    if (!res.data?.error) {
      setData(res.data.data);
      setPages(Math.ceil(res.data.total / pageSize));
    }
  };

  useEffect(() => {
    getTransferHistory();
  }, [currentPage, pageSize]);

  useEffect(() => {
    if (Array.isArray(settings) && settings.length > 0) {
      const transferStatus = settings[0].transfer_status;
      const reason = settings[0].transfer_msg;
      setTransferStatus(transferStatus === true);
      setTransferReason(reason || '');
    }
  }, [settings]);

  const customStyles = `
    .transfer-form-body { padding: 8px 12px 16px; }

    .transfer-eco-balance-card {
      display: flex; align-items: center; justify-content: space-between; gap: 16px;
      margin: 20px 0 24px; padding: 18px 20px; border-radius: 18px;
      background: linear-gradient(135deg, rgba(0, 111, 227, 0.08), rgba(16, 185, 129, 0.06));
      border: 1px solid rgba(0, 111, 227, 0.15);
      box-shadow: 0 8px 24px rgba(0, 111, 227, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8);
    }
    .transfer-eco-balance-label {
      font-size: 11px; text-transform: uppercase; letter-spacing: 1.5px;
      color: #64748b; font-weight: 800; margin-bottom: 4px;
    }
    .transfer-eco-balance-amount {
      font-size: 26px; font-weight: 800; color: #006fe3; line-height: 1.1;
    }
    .transfer-eco-balance-icon {
      width: 52px; height: 52px; border-radius: 14px; flex-shrink: 0;
      display: flex; align-items: center; justify-content: center;
      background: linear-gradient(135deg, #006fe3, #0058b0);
      color: #fff; font-size: 20px;
      box-shadow: 0 8px 20px rgba(0, 111, 227, 0.3);
    }

    .db-input-group { margin-bottom: 20px; position: relative; }
    .db-input-label {
      font-size: 11px; text-transform: uppercase; letter-spacing: 1.5px;
      color: #64748b; font-weight: 800; margin-bottom: 8px; display: block;
    }
    .db-input-box {
      background: rgba(238, 242, 246, 0.5);
      border-radius: 16px; padding: 12px 20px;
      border: 1px solid rgba(255, 255, 255, 0.8);
      box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
      display: flex; align-items: center; gap: 12px;
      transition: all 0.3s;
    }
    .db-input-box:focus-within { border-color: #006fe3; background: #fff; }
    .db-input-icon-box {
      width: 36px; height: 36px; border-radius: 10px;
      display: flex; align-items: center; justify-content: center; flex-shrink: 0;
      background: rgba(0, 111, 227, 0.1); color: #006fe3; font-size: 14px;
    }
    .db-input-field {
      background: transparent !important; border: none !important; outline: none !important;
      width: 100%; font-weight: 700; color: #1e293b; font-size: 16px;
      box-shadow: none !important; padding: 0 !important; border-radius: 0 !important;
      -webkit-appearance: none; appearance: none;
    }
    .db-input-box input[type="number"] { -moz-appearance: textfield; }
    .db-input-box input[type="number"]::-webkit-inner-spin-button,
    .db-input-box input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none; margin: 0;
    }
    .db-input-field:focus,
    .db-input-field:focus-visible {
      border: none !important; outline: none !important; box-shadow: none !important;
    }
    .db-input-field::placeholder { color: #94a3b8; font-weight: 500; }
    .db-input-field:disabled { opacity: 0.6; cursor: not-allowed; }

    .transfer-verify-msg {
      display: flex; align-items: center; margin-bottom: 14px;
      padding: 10px 14px; font-size: 13px; font-weight: 700;
      border-radius: 12px;
    }
    .transfer-verify-msg.text-success {
      background: rgba(16, 185, 129, 0.1); border: 1px solid rgba(16, 185, 129, 0.2);
    }
    .transfer-verify-msg.text-danger {
      background: rgba(239, 68, 68, 0.08); border: 1px solid rgba(239, 68, 68, 0.15);
    }

    .transfer-otp-box {
      padding: 24px 20px; margin: 16px 0; border-radius: 16px;
      background: #f8fafc; border: 1px dashed #cbd5e1; text-align: center;
    }
    .transfer-otp-label {
      margin-bottom: 14px; color: #64748b; font-weight: 700;
      font-size: 12px; letter-spacing: 1px; text-transform: uppercase;
    }
    .transfer-otp-input { max-width: 220px; margin: 0 auto; }

    .transfer-btn {
      width: 100%; padding: 14px 20px; margin-top: 8px;
      border: none; border-radius: 16px; font-weight: 800;
      font-size: 14px; letter-spacing: 0.5px; cursor: pointer;
      transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
    }
    .transfer-btn:hover:not(:disabled) { transform: translateY(-1px); }
    .transfer-btn:disabled { opacity: 0.65; cursor: not-allowed; }
    .transfer-btn-primary {
      background: linear-gradient(135deg, #10b981, #059669);
      color: #fff; box-shadow: 0 10px 20px rgba(16, 185, 129, 0.3);
    }
    .transfer-btn-confirm {
      background: linear-gradient(135deg, #3b82f6, #2563eb);
      color: #fff; border-radius: 12px; box-shadow: 0 8px 16px rgba(59, 130, 246, 0.25);
    }
    .transfer-btn-action {
      background: linear-gradient(135deg, #f59e0b, #d97706);
      color: #fff; box-shadow: 0 10px 20px rgba(245, 158, 11, 0.3);
    }

    .transfer-form-hint {
      text-align: center; padding: 20px 16px; margin-top: 8px;
      color: #94a3b8; font-size: 13px; font-weight: 600; line-height: 1.5;
      background: rgba(248, 250, 252, 0.8); border-radius: 14px;
      border: 1px dashed #e2e8f0;
    }
    .transfer-form-hint i { margin-right: 6px; color: #cbd5e1; }

    .transfer-loader-overlay {
      position: absolute; inset: 0; z-index: 20;
      background: rgba(255, 255, 255, 0.92);
      backdrop-filter: blur(4px);
      display: flex; flex-direction: column;
      align-items: center; justify-content: center;
      border-radius: 44px; padding: 24px;
    }
    .transfer-loader-spinner {
      width: 48px; height: 48px;
      border: 4px solid rgba(0, 111, 227, 0.15);
      border-top-color: #006fe3; border-radius: 50%;
      animation: transferEcoSpin 0.8s linear infinite;
    }
    @keyframes transferEcoSpin { to { transform: rotate(360deg); } }
    .transfer-loader-text {
      margin-top: 16px; color: #64748b; font-size: 14px; font-weight: 700;
    }

    @media (max-width: 768px) {
      .transfer-form-body { padding: 4px 4px 12px; }
      .transfer-eco-balance-card { padding: 14px 16px; margin: 16px 0 20px; }
      .transfer-eco-balance-amount { font-size: 22px; }
      .db-input-group { margin-bottom: 16px; }
      .db-input-box { padding: 10px 14px; border-radius: 12px; }
      .db-input-field { font-size: 15px; }
      .transfer-btn { padding: 13px 16px; font-size: 13px; border-radius: 14px; }
    }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Header />

        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">

              <div className="col-lg-6 col-md-10 col-12">

                {TransferStatus === false && (
                  <div className="alert alert-danger mb-4 shadow-sm border-0" style={{ background: '#450a0a', color: '#fca5a5' }}>
                    <i className="fa fa-ban me-2"></i> {TransferReason || "Transfers Disabled"}
                  </div>
                )}

                {TransferStatus === true && (
                  <div className="db-profile-card mb-5" style={{ position: 'relative' }}>
                    {transferLoading && (
                      <div className="transfer-loader-overlay">
                        <div className="transfer-loader-spinner" />
                        <p className="transfer-loader-text mb-0">Processing ecosystem transfer...</p>
                      </div>
                    )}

                    <div className="db-sec-hdr">
                      <div className="db-sec-dot"></div>
                      <div className="db-sec-title">Send Funds</div>
                    </div>

                    <div className="transfer-form-body">

                      <div className="transfer-eco-balance-card">
                        <div>
                          <div className="transfer-eco-balance-label">Ecosystem Wallet Balance</div>
                          <div className="transfer-eco-balance-amount">
                            ${udata?.ecosystem_balance?.toFixed(2) || "0.00"}
                          </div>
                        </div>
                        <div className="transfer-eco-balance-icon">
                          <i className="fas fa-wallet"></i>
                        </div>
                      </div>

                      <div className="db-input-group">
                        <label className="db-input-label">Recipient User ID</label>
                        <div className="db-input-box">
                          <div className="db-input-icon-box">
                            <i className="fa fa-user"></i>
                          </div>
                          <input
                            className="db-input-field"
                            placeholder="Enter User ID"
                            value={add}
                            onChange={(e) => setAdd(e.target.value)}
                            disabled={showOtp || transferLoading}
                          />
                        </div>
                      </div>

                      {userCheckLoading && add && (
                        <div className="transfer-verify-msg text-secondary">
                          <i className="fa fa-spinner fa-spin me-2"></i> Verifying user...
                        </div>
                      )}
                      {toUserName && (
                        <div className="transfer-verify-msg text-success">
                          <i className="fa fa-check-circle me-2"></i>
                          Verified: <b className="ms-1">{toUserName}</b>
                        </div>
                      )}
                      {userCheckError && (
                        <div className="transfer-verify-msg text-danger">
                          <i className="fa fa-times-circle me-2"></i> {userCheckError}
                        </div>
                      )}

                      <div className="db-input-group">
                        <label className="db-input-label">Amount to Transfer</label>
                        <small className="d-block mb-2 text-muted" style={{ fontSize: '12px', fontWeight: 600 }}>
                          Round figure only — whole numbers (e.g. 100, 500)
                        </small>
                        <div className="db-input-box">
                          <div className="db-input-icon-box">
                            <i className="fas fa-dollar-sign"></i>
                          </div>
                          <input
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            className="db-input-field"
                            placeholder="Enter amount"
                            value={amt}
                            onChange={handleAmountChange}
                            disabled={showOtp || transferLoading}
                          />
                        </div>
                      </div>

                      {showOtp && (
                        <div className="transfer-otp-box">
                          <div className="transfer-otp-label">Enter OTP Code</div>
                          <div className="db-input-box transfer-otp-input">
                            <input
                              className="db-input-field text-center fs-4 p-0"
                              placeholder="• • • • • •"
                              maxLength={6}
                              value={otp}
                              onChange={(e) => { if (/^[0-9]*$/.test(e.target.value)) setOtp(e.target.value); }}
                              style={{ letterSpacing: '8px' }}
                            />
                          </div>
                          <button
                            type="button"
                            className="transfer-btn transfer-btn-confirm mt-3"
                            onClick={withdraw}
                            disabled={transferLoading}
                          >
                            {transferLoading ? "PLEASE WAIT..." : "CONFIRM IDENTITY"}
                          </button>
                        </div>
                      )}

                      <div className="mt-2">
                        {!showOtp && !otpVerified && toUserName && !userCheckError && (
                          <button
                            type="button"
                            className="transfer-btn transfer-btn-primary"
                            onClick={sendOtp}
                            disabled={loadingOtp || !isRoundAmount(amt)}
                          >
                            {loadingOtp ? "SENDING..." : "PROCEED VERIFICATION"}
                          </button>
                        )}

                        {otpVerified && toUserName && (
                          <button
                            type="button"
                            className="transfer-btn transfer-btn-action"
                            onClick={withdraw}
                            disabled={transferLoading}
                          >
                            {transferLoading ? "PROCESSING..." : "TRANSFER FUNDS NOW"}
                          </button>
                        )}

                        {!showOtp && !otpVerified && !toUserName && !userCheckError && (
                          <div className="transfer-form-hint">
                            <i className="fa fa-info-circle"></i>
                            Enter a valid recipient User ID and amount to continue
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* History Table - USING STAKING.JSX STYLE */}
            <div className="row justify-content-center">
              <div className="col-lg-10 col-12">
                <div className="db-profile-card mb-5">

                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Recent Ecosystem Transfers</div>
                  </div>

                  <div className="card-body p-0 mt-3">
                    <div className="table-responsive">
                      <table className="table table-dashboard-premium align-middle mb-0" style={{ minWidth: '700px' }}>
                        <thead className="text-uppercase small">
                          <tr>
                            <th scope="col" className="ps-4 py-3" style={{ width: '10%' }}>Sr.</th>
                            <th scope="col" className="py-3" style={{ width: '20%' }}>Amount</th>
                            <th scope="col" className="py-3" style={{ width: '40%' }}>From/To</th>
                            <th scope="col" className="py-3" style={{ width: '30%' }}>Status</th>
                            <th scope="col" className="pe-4 py-3 text-end" style={{ width: '30%' }}>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && !data.length ? (
                            <tr>
                              <td colSpan="5" className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : !data.length ? (
                            <tr>
                              <td colSpan="5" className="text-center py-5 text-slate-400">
                                <p className="mb-0">No records found</p>
                              </td>
                            </tr>
                          ) : (
                            data.map((e, i) => (
                              <tr key={i} className="table-tr-premium">
                                <td className="ps-4">
                                  <span className="text-slate-400 small">{currentPage * pageSize - pageSize + (i + 1)}</span>
                                </td>

                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="bg-soft-primary rounded-circle p-2 me-2 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                                      <i className="fa fa-dollar-sign text-xs"></i>
                                    </div>
                                    <span className="fw-bold text-white-custom fs-6">{e.amount?(e.amount).toFixed(2):"0.00"}</span>
                                  </div>
                                </td>

                                <td>
                                  <div className="d-flex align-items-center">
                                    {/* <span className="text-slate-400 me-2 small">Recipient:</span> */}
                                    <span className="text-white-custom fw-semibold">
                                      {e.to === null ? "Self" : e.from === udata?.username ? e.to : e.from}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <span
                                      className={`fw-semibold ${e.to === null || e.to === udata?.username
                                        ? "text-success"
                                        : "text-danger"
                                        }`}
                                    >
                                      {e.to === null || e.to === udata?.username
                                        ? "Received"
                                        : "Sent"}
                                    </span>
                                  </div>
                                </td>

                                <td className="pe-4 text-end">
                                  {e.date ? (
                                    <div className="small text-slate-400">{formatDateTime(e.date)}</div>
                                  ) : '-'}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>
      </div>
    </>
  );
}
